export default __webpack_public_path__ + "static/media/ysd-008-setu5.122fbfcd.jpg";